import { Button, HStack, Spinner, Text } from '@chakra-ui/react';
import React from 'react';

interface ItemCountManagerProps {
    item: any;
    isIncrementing: boolean;
    isDecrementing: boolean;
    onIncrement: (id: string) => void;
    onDecrement: (id: string) => void;
    onRemove: (id: string) => void;

}

const ItemCountManager: React.FC<ItemCountManagerProps> = ({
    item,
    isIncrementing,
    isDecrementing,
    onIncrement,
    onDecrement,
    onRemove,
}) => {

    const canDecrement = item.quantity >= 1;
    const canIncrement = item.isLimitedUnits ? item.quantity < item.units : true;


    return (
        <HStack align="center" justify="center">
            <HStack spacing={0} align="center" justify="center" bg="white" borderRadius="md" display="inline-flex">
                <Button
                    aria-label={`Decrease quantity`}
                    size="sm"
                    variant="ghost"
                    isDisabled={!canDecrement || isDecrementing}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (canDecrement) {
                            onDecrement(item._id);
                        }
                    }}
                    data-testid={`decrease-quantity-${item.itemId}`}
                    minW="40px"
                    h="40px"
                    p={0}
                    fontSize="xl"
                    fontWeight="bold"
                    borderRadius="md"
                    color="primary.500"
                    _hover={{ bg: '#E0E0E0' }}
                >
                    {isDecrementing ? <Spinner size="sm" /> : '−'}
                </Button>
                <Text fontSize="sm" fontWeight="bold" minW="40px" textAlign="center" color="#121212">
                    {item.quantity || 1}
                </Text>
                <Button
                    aria-label={`Increase quantity`}
                    size="sm"
                    variant="ghost"
                    isDisabled={isIncrementing /*|| !canIncrement */}
                    onClick={(e) => {
                        e.stopPropagation();
                        // if (canIncrement) {
                            onIncrement(item._id);
                        // }
                    }}
                    data-testid={`increase-quantity-${item.itemId}`}
                    minW="40px"
                    h="40px"
                    p={0}
                    fontSize="xl"
                    fontWeight="bold"
                    borderRadius="md"
                    color="primary.500"
                    _hover={{ bg: '#E0E0E0' }}
                >
                    {isIncrementing ? <Spinner size="sm" /> : '+'}
                </Button>
            </HStack>
        </HStack>
    );
};

export default ItemCountManager;
